// istanbul ignore file
import {
  QueryCache,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type PropsWithChildren, useState } from 'react';

const QueryProvider = ({ children }: PropsWithChildren) => {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // NOTE: Disabling this because we're seeing unwanted redirection to 404 page on window refocus
            refetchOnWindowFocus: false
          }
        },
        queryCache: new QueryCache({
          onError: (error, query) => {
            if (
              query.meta?.onQueryError &&
              typeof query.meta.onQueryError === 'function'
            ) {
              query.meta.onQueryError(error);
            }
          },
          onSuccess: (data, query) => {
            if (
              query.meta?.onQuerySuccess &&
              typeof query.meta.onQuerySuccess === 'function'
            ) {
              query.meta.onQuerySuccess(data);
            }
          }
        })
      })
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default QueryProvider;
